import React , { useState, useEffect }from "react";
import Navbar from "../components/mainNavBar";
import HomeFooter from "../components/homefooter";
import { useNavigate } from "react-router-dom";


export default function HomePage() {
  const navigate = useNavigate();
  const [videoUrl, setVideoUrl] = useState("");
  const [showVideoModal, setShowVideoModal] = useState(false);

  const VIDEO_BUCKET = "gi-website-media";
  const VIDEO_KEY = "Generative_Insight_Video.mp4";

  useEffect(() => {
    fetchVideoUrl();
  }, []);

  const fetchVideoUrl = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/getS3Url`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            bucket: VIDEO_BUCKET,
            key: VIDEO_KEY,
          }),
        }
      );

      const data = await res.json();
      if (data.success && data.preSignedUrl) {
        setVideoUrl(data.preSignedUrl);
      }
    } catch (err) {
      console.error("Error fetching video URL:", err);
    }
  };
   const openVideoModal = () => {
    setShowVideoModal(true);
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
  };
  return (
    <>
      <Navbar />
      <main className="homepage">
        <section className="hero">
          <div className="hero-text">
            <h1>Add AI-Powered Market Research to Your Toolkit</h1>
            <p>
              Generate comprehensive market insights in hours—complete with
              statistical analysis, banner books, a final report, and
              interactive segment avatars.
            </p>
            <div className="hero-buttons">
              <button
                className="primary-btn"
                onClick={() => navigate("/create-survey")}
              >
                Start Your Research Project
              </button>
              <button className="secondary-btn" onClick={openVideoModal} >Watch Demo Video</button>
            </div>
          </div>
          <div className="hero-image">
            <div className="placeholder hero-placeholder">
              <img
                className="img-responsive "
                alt="Generative Insights"
                src="/json-media/img/homepage/homepagebanner1.webp"
              />
            </div>
          </div>
        </section>

        <section className="section generative-insight">
          <h2>Generative Insight delivers</h2>
          <div className="features-grid-home">
            <div className="feature-card-home">
              <h4>Deep Segment Profiles</h4>
              <p>
                based on millions of profiles, each with thousands of data
                attributes
              </p>
            </div>
            <div className="feature-card-home">
              <h4>Full Statistical Rigor</h4>
              <p>
                precise target sampling, factor and cluster analysis, and a full
                banner book
              </p>
            </div>
            <div className="feature-card-home">
              <h4>Essential New Method</h4>
              <p>
                to complement traditional surveys, focus groups, and
                ethnographic research
              </p>
            </div>
            <div className="feature-card-home">
              <h4>Expand Research Capabilities</h4>
              <p>With instant comprehensive insight</p>
            </div>
            <div className="feature-card-home">
              <h4>Unlimited Questioning</h4>
              <p>of hard-to-reach segments</p>
            </div>
          </div>
        </section>
          <section className="section video-showcase">
          <div className="video-container">
            <div className="video-wrapper">
              {videoUrl && (
                <video
                  className="background-video"
                  controls
                  playsInline
                  loop
                >
                  <source src={videoUrl} type="video/mp4" />
                </video>
              )}
            </div>
          </div>
        </section>


        <section className="section researcher-tools">
          <h3>Every Researcher Needs Multiple Tools</h3>
          <p>
            Expand your toolkit with new, AI-powered insights... the perfect
            tool for some of your most urgent and important research needs
          </p>
        </section>
        <section class="section toolkit-comparison">
          <h2>Current Toolkit comparison</h2>
          <div>
            <div class="comparison-placeholder">
              <img
                class="img-responsive"
                alt="Current Toolkit comparison"
                src="/json-media/img/homepage/Toolkitimg.webp"
              />
            </div>
          </div>
        </section>

        <section className="section unlock-insights">
          <div className="unlock-content">
            <div className="unlock-text">
              <div className="hero-buttons">
                <div>
                  <button
                    className="primary-btn"
                    onClick={() => navigate("/create-survey")}
                  >
                    Start Your Research Project
                  </button>
                </div>
                <div><button className="secondary-btn" onClick={openVideoModal}>Watch Demo</button></div>
              </div>
            </div>
          </div>
        </section>

        <section className="section features-bottom">
          <h2>
            Generative Insight delivers unprecedented <br /> speed and value to
            researchers
          </h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <div className="placeholder icon-placeholder">
                  <img
                    className="img-responsive"
                    alt="Research Acceleration"
                    src="/json-media/img/homepage/icon-1.svg"
                  />
                </div>
              </div>
              <h4>Research Acceleration</h4>
              <p>Get comprehensive insights in hours instead of weeks.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <div className="placeholder icon-placeholder">
                  <img
                    className="img-responsive"
                    alt="Unlimited Capabilities"
                    src="/json-media/img/homepage/icon-2.svg"
                  />
                </div>
              </div>
              <h4>Unlimited Capabilities</h4>
              <p>
                No constraints on question counts, audience targeting, or
                conversation topics.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <div className="placeholder icon-placeholder">
                  <img
                    className="img-responsive"
                    alt="Living Intelligence"
                    src="/json-media/img/homepage/icon-3.svg"
                  />
                </div>
              </div>
              <h4>Living Intelligence</h4>
              <p>
                Move beyond static datasets to ongoing, customized analysis.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <div className="placeholder icon-placeholder">
                  <img
                    className="img-responsive"
                    alt="Statistical Rigor"
                    src="/json-media/img/homepage/icon-4.svg"
                  />
                </div>
              </div>
              <h4>Statistical Rigor</h4>
              <p>
                Full rigor of research with factor analysis, clustering and
                segmentation.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <div className="placeholder icon-placeholder">
                  <img
                    className="img-responsive"
                    alt="Cost Optimization"
                    src="/json-media/img/homepage/icon-5.svg"
                  />
                </div>
              </div>
              <h4>Cost Optimization</h4>
              <p>
                Focus on your primary / sweet spot on validated opportunities.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <div className="placeholder icon-placeholder">
                  <img
                    className="img-responsive"
                    alt="Complementary Toolkit"
                    src="/json-media/img/homepage/icon-6.svg"
                  />
                </div>
              </div>
              <h4>Complementary Toolkit</h4>
              <p>Designed to work alongside your existing research methods.</p>
            </div>
          </div>
        </section>
      </main>
      {showVideoModal && (
        <div className="video-modal" onClick={closeVideoModal}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="video-modal-close" onClick={closeVideoModal}>
              ×
            </button>
            {videoUrl && (
              <video
                className="modal-video-player"
                controls
                autoPlay
                src={videoUrl}
              >
                <source src={videoUrl} type="video/mp4" />
              </video>
            )}
          </div>
        </div>
      )}
      <HomeFooter />
    </>
  );
}
